module.exports = __webpack_public_path__ + "assets/img/11_725_4.199e7683.jpg";